import React, { useEffect, useState } from 'react';
import './About.css';
import { API_BASE_URL } from '../config';

interface AboutSection {
  id: number;
  description: string;
  icon: string | null;
  created_at: string;
}

interface AboutData {
  id: number;
  header: string;
  description: string;
  avatar: string | null;
  sections: AboutSection[];
  created_at: string;
  updated_at: string;
}

const About: React.FC = () => {
  const [aboutData, setAboutData] = useState<AboutData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    document.title = 'About | Patates | Guesthouse in Martuni';
  }, []);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/about/`);
        if (!response.ok) {
          throw new Error('Failed to fetch about data');
        }
        const data = await response.json();
        setAboutData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };
    fetchAbout();
  }, []);

  if (loading) {
    return (
      <div className="about-page">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="about-page">
        <div className="error">
          <p>Error: {error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="about-page">
      {/* Single Hero Section with all content */}
      <section className="about-hero">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h1>{aboutData?.header || 'About Patates'}</h1>
              <div className="about-description">
                {aboutData?.description ? (
                  aboutData.description.split('\n').map((line, index) => (
                    <p key={index}>{line}</p>
                  ))
                ) : (
                  <p>Discover our story and what makes us special</p>
                )}</div>
              
              {/* Sections list under description */}
              {aboutData?.sections && aboutData.sections.length > 0 && (
                <div className="sections-list">
                  {aboutData.sections.map((section) => (
                    <div key={section.id} className="about-section-item">
                      <div className="section-icon">
                        {section.icon ? (
                          <img src={section.icon} alt="Section icon" />
                        ) : (
                          '✨'
                        )}
                      </div>
                      <div className="section-text">
                        <p>{section.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {aboutData?.avatar && (
              <div className="about-image">
                <img 
                  src={aboutData.avatar} 
                  alt="About Avatar" 
                  className="about-avatar"
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 